export default __webpack_public_path__ + "static/media/object-document_darkGray3.13ae322a.svg";